import React from "react";
import styled from "styled-components";
import HeroBgAnimation from "../HeroBgAnimation";
import { Bio } from "../../data/constants";
import Typewriter from "typewriter-effect";
import Profile from "../../images/profile.jpg";
import { motion } from "framer-motion";
import Reveal from "../common/Reveal";
const MainContainer = styled.div`
  background-color: ${({ theme }) => theme.card_light};
  display: flex;
  justify-content: center;
  position: relative;
  padding: 80px 30px;
  @media screen and (max-width: 960px) {
    padding: 66px 16px;
  }
  @media screen and (max-width: 640px) {
    padding: 32px 16px;
  }
  z-index: 1;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 70% 95%, 0 100%);
`;
const MainInnerContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1100px;

  @media (max-width: 960px) {
    flex-direction: column;
  }
`;
const MainLeftContainer = styled.div`
  width: 100%;
  order: 1;
  @media (max-width: 960px) {
    order: 2;
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media (max-width: 640px) {
    order: 2;
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;
const MainRightContainer = styled.div`
  width: 100%;
  display: flex;
  order: 2;
  justify-content: end;
  gap: 12px;
  position: relative;
  @media (max-width: 960px) {
    order: 1;
    justify-content: center;
    align-items: center;
    margin-bottom: 80px;
  }

  @media (max-width: 640px) {
    margin-bottom: 30px;
  }
`;

const PhotoBg = styled.div`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: min(560px, 92%);
  aspect-ratio: 1 / 1;
  z-index: 0;
  opacity: 0.85;
  filter: saturate(1.05);

  @media (max-width: 960px) {
    right: 50%;
    transform: translate(50%, -50%);
    width: min(560px, 94vw);
    opacity: 0.9;
  }
`;
const TextLoop = styled.div`
  font-weight: 600;
  font-size: 32px;
  display: flex;
  gap: 12px;
  color: ${({ theme }) => theme.text_primary};
  line-height: 68px;
  @media (max-width: 960px) {
    text-align: center;
  }
  @media (max-width: 640px) {
    font-size: 22px;
    line-height: 48px;
    margin-bottom: 16px;
  }
`;
const Span = styled.span`
  color: ${({ theme }) => theme.primary};
  cursor: pointer;
`;

const SubTitle = styled.div`
  font-size: 20px;
  line-height: 32px;
  margin-bottom: 42px;
  color: ${({ theme }) => theme.text_primary + 95};

  @media (max-width: 960px) {
    text-align: center;
  }

  @media (max-width: 640px) {
    font-size: 16px;
    line-height: 32px;
  }
`;
const ResumeButton = styled.a`
    -webkit-appearance: button;
    -moz-appearance: button;
    appearance: button;
    text-decoration: none;
    width: 95%;
    max-width: 300px;
    text-align: center;
    padding: 16px 0;
    color:${({ theme }) => theme.white};
    border-radius: 20px;
    cursor: pointer;
    font-size: 20px;
    font-weight: 600;
    transition: all 0.2s ease-in-out !important;
    // background: hsla(271, 100%, 50%, 1);
    // background: linear-gradient(225deg, hsla(271, 100%, 50%, 1) 0%, hsla(294, 100%, 50%, 1) 100%);
    // background: -moz-linear-gradient(225deg, hsla(271, 100%, 50%, 1) 0%, hsla(294, 100%, 50%, 1) 100%);
    // background: -webkit-linear-gradient(225deg, hsla(271, 100%, 50%, 1) 0%, hsla(294, 100%, 50%, 1) 100%);
    background: rgb(37,32,213);
    background: linear-gradient(90deg, rgba(37,32,213,1) 5%, rgba(35,234,235,1) 68%);
    box-shadow:  20px 20px 60px #1F2634,
    -20px -20px 60px #1F2634;
    &:hover {
        transform: scale(1.05);
    transition: all 0.4s ease-in-out;
    box-shadow:  20px 20px 60px #1F2634,
    filter: brightness(1);
    }    
    
    
    @media (max-width: 640px) {
        padding: 12px 0;
        font-size: 18px;
    } 

`;

const Titles = styled.div`
  font-weight: 700;
  font-size: 50px;
  color: ${({ theme }) => theme.text_primary};
  line-height: 68px;
  @media (max-width: 960px) {
    text-align: center;
  }

  @media (max-width: 640px) {
    font-size: 40px;
    line-height: 48px;
    margin-bottom: 8px;
  }
`;
const ImageWrap = styled.div`
  position: relative;
  width: 85%;
  max-width: 410px;
  aspect-ratio: 1 / 1;
  border-radius: 999px;
  display: grid;
  place-items: center;
  z-index: 2;

  &:before {
    content: "";
    position: absolute;
    inset: -10px;
    border-radius: 999px;
    background: conic-gradient(
      from 180deg,
      #00aeef,
      #23eaeb,
      #f9eb0c,
      #ff4f49,
      #00aeef
    );
    filter: blur(10px);
    opacity: 0.75;
    animation: spinGlow 10s linear infinite;
    z-index: 0;
  }

  &:after {
    content: "";
    position: absolute;
    inset: -1px;
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.22);
    z-index: 1;
  }

  @keyframes spinGlow {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @media (max-width: 640px) {
    max-width: 290px;
  }
`;

const Image = styled.img`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 999px;
  object-fit: cover;
  z-index: 2;
  border: 1px solid rgba(255, 255, 255, 0.18);
  box-shadow: 0 18px 60px rgba(0, 0, 0, 0.55);
`;
const SubHead = styled.div`
  font-size: 20px;
  line-height: 32px;
  margin-bottom: 27px;
  margin-top: 15px;
  color: #00aeef;

  @media (max-width: 960px) {
    text-align: center;
  }

  @media (max-width: 640px) {
    font-size: 16px;
    line-height: 32px;
  }
`;

const HeroSec = () => {
  return (
    <div id="about">
      <MainContainer>
        <MainInnerContainer>
          <MainLeftContainer>
            <Reveal as={motion.div} delay={0.0}>
              <Titles>
                Hello, I am <br /> {Bio.name}{" "}
              </Titles>
            </Reveal>
            <Reveal as={motion.div} delay={0.08}>
              <SubHead>Finalist @Barclays Hack-O-Hire'24</SubHead>
            </Reveal>
            <Reveal as={motion.div} delay={0.12}>
              <TextLoop>
                I am a
                <Span style={{ color: "#00aeef" }}>
                  <Typewriter
                    options={{
                      strings: Bio.roles,
                      autoStart: true,
                      loop: true,
                    }}
                  />
                </Span>
              </TextLoop>
            </Reveal>
            <Reveal as={motion.div} delay={0.18}>
              <SubTitle>{Bio.description}</SubTitle>
            </Reveal>
            <Reveal as={motion.div} delay={0.24}>
              <ResumeButton href={Bio.resume} target="_blank" rel="noreferrer">
                Check For Resume
              </ResumeButton>
            </Reveal>
          </MainLeftContainer>
          <MainRightContainer>
            <PhotoBg aria-hidden="true">
              <HeroBgAnimation />
            </PhotoBg>
            <Reveal as={motion.div} delay={0.1} y={18}>
              <ImageWrap>
                <Image src={Profile} alt="Profile" />
              </ImageWrap>
            </Reveal>
          </MainRightContainer>
        </MainInnerContainer>
      </MainContainer>
    </div>
  );
};

export default HeroSec;
